<template>
  <ul id="country-code-list" :class="style['form-wrap']">
    <li v-for="code in countryCodes" @click="updateCountryCode(code)">
      <span :class="style['flag']">{{ code.flag }}</span>
      <span :class="style['country-name']">{{ code.name[$i18n.locale] }}</span>
      <span :class="style['country-code']">{{ code.code }}</span>
    </li>
  </ul>
</template>

<script>
import style from './scss/_pages.scss'
import countryCodes from './countries.json'
import { useDetailsPageStore } from 'Store/details-page'
import { mapState } from 'pinia'
import { useFormStore } from 'Store/form'

export default {
  setup() {
    return {
      detailsPageStore: useDetailsPageStore(),
      formStore: useFormStore()
    }
  },

  data() {
    return {
      style,
      countryCodes
    }
  },
  computed: {
    ...mapState(useFormStore, {
      contactForm: 'contactForm'
    })
  },
  methods: {
    updateCountryCode(code) {
      this.contactForm.countryCode = code.code
      this.detailsPageStore.setDetailsPageShown('ContactForm')
    }
  }
}
</script>
